import { NewCustomFieldOption } from './CustomFieldsMenu';

export const CUSTOM_FIELDS: Array<NewCustomFieldOption> = [
  {
    name: 'Phone number',
    type: 'phoneNumber',
  },

  {
    name: 'Email',
    type: 'email',
  },

  {
    name: 'URL',
    type: 'url',
  },
  {
    name: 'Text',
    type: 'text',
  },
  {
    name: 'Number',
    type: 'number',
  },
  {
    name: 'Address',
    type: 'address',
  },
  {
    name: 'Tags',
    type: 'multiSelect',
    options: [],
  },
];
